import { ValidatedInput } from '@cp-shared-19/frontend-ui';
import { Modal, Paragraph } from '@vwfs-bronson/bronson-react';
import React from 'react';

export type EmailInputProps = {
    show: boolean;
    onConfirm: () => void;
    onClose: () => void;
    name?: string;
    /** Blocks the confirm button while the submission it triggers is still in flight. */
    disabled?: boolean;
};

export const EmailInputModal: React.FC<EmailInputProps> = ({
    show,
    onConfirm,
    onClose,
    name = 'email',
    disabled = false,
}) => {
    return (
        <Modal
            shown={show}
            onClose={onClose}
            onCancel={onClose}
            onClickOutside={onClose}
            buttonCancelText={'Annuler'}
            buttonConfirmText={'Soumettre'}
            onConfirm={() => onConfirm()}
            confirmationDisabled={disabled}
            testId={'missing-email-modal'}
            title="Adresse email manquante !"
        >
            <Paragraph>
                Afin de vous envoyer un accusé de réception à la bonne adresse email, veuillez remplir le champ
                ci-dessous :
            </Paragraph>
            <ValidatedInput
                requiredText=" *"
                name={name}
                id="emailModalInput"
                label="email"
                inputMode="email"
                required={true}
                isMandatory={true}
            />
        </Modal>
    );
};
